"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M28.288 19.938l-9.839 6.827a.788.788 0 0 1-.9 0l-9.837-6.827L1.858 24a.25.25 0 0 0 0 .411l15.85 11a.512.512 0 0 0 .584 0l15.85-11a.25.25 0 0 0 0-.411z" }),
  React.createElement("path", { d: "M17.7 22.988L1.858 12a.25.25 0 0 1 0-.411L17.7.594a.529.529 0 0 1 .6 0l15.842 10.992a.25.25 0 0 1 0 .411L18.3 22.988a.529.529 0 0 1-.6 0z" })
);

